PJQ.views.commitments.CommitmentsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'commitments-list'),
        commitmentId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .new-po': 'newCommitment',
        'click .new-subcontract': 'newCommitment',
        'click .btn-view-commitment': 'viewCommitmentClicked',
        'click .btn-delete-commitment': 'deleteCommitmentClicked',
        'click .btn-export': 'exportList',
        'click .btn-pull-erp': 'pullERP',
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.commitments.Commitments(null, {
                projectId: this.options.project.get('projectId'),
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }
        this.settings = await this.options.project.fetchCommitmentSettings();

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.userSettings = await PJQ.app.session.fetchCommitmentUserSettings();
        this.customFields = await this.options.project.fetchCommitmentCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('commitments.canEdit');
        this.options.isChangeOrdersAdmin = this.options.project.hasPermission('commitmentChangeOrders.isAdmin');
        this.options.isAdmin = this.options.project.hasPermission('commitments.isAdmin');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('commitmentChanged');
        PJQ.app.session.project.on('commitmentChanged', function (commitment) {
            this.collection.add(commitment);
            this.render();
        }, this);

        if (this.options.commitmentId > 0) {
            let initCommitment = this.collection.get(this.options.commitmentId);
            if (initCommitment != null) {
                this.viewCommitment(initCommitment);
                this.options.commitmentId = null;
            }
        }
    },
    renderERPButton: function () {
        let $erp = this.$('.erp-sync')
        if (!this.options.isAdmin || this.erpIntegration == null || !this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS) || !this.options.project || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENTS);
        if(pullSupported && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENTS_DOC_CLERK_REQUIRED) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)){
            pullSupported = false;
        }

        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: false,
            pullSupported: pullSupported
        });
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMMITMENTS)) {
            this.erpIntegration.pullCommitments(this.options.project, _.bind(function (res) {
                PJQ.notifications.notify.successNotify({
                    message: 'Commitments successfully pulled from ERP'
                });

                this.collection.reset(res);
                this.render();
            }, this));
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.commitments.CommitmentDataTable({
            el: this.$('.commitments-data'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    canAdd: this.options.canEdit,
                    isAdmin: this.options.isAdmin,
                    settings: this.settings
                };
            }, this),
            enableColumnResize: true,
            groups: this.groups,
            costTypes: this.costTypes,
            columnWidthCookie: PJQ.constants.cookies.COMMITMENT_LIST_COLUMNS_WIDTH,
            unitsOfMeasure: this.unitsOfMeasure,
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.commitments.view.COMMITMENTS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewCommitment(row.data());
            }, this),
            afterDataTableRender: _.bind(function () {
                if (PJQ.app.session.erpIntegration && PJQ.app.session.erpIntegration.id > 0) {
                    this.renderERPButton();
                }
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewCommitment(row.data());
                        }, this)
                    },
                    {
                        name: 'New Change Order',
                        isShown: _.bind(function (row) {
                            let status = row.data().get('statusId');
                            return this.options.isAdmin && this.options.isChangeOrdersAdmin && status !== PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_TERMINATED && status !== PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_CLOSED;
                        }, this),
                        onClick: _.bind(function (row) {
                            new PJQ.views.commitments.ChangeOrderEditModal({
                                commitment: row.data()
                            });
                        }, this)
                    }
                ]
            }
        });
    },
    exportList: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'commitments'
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ]), {isAPIv2: true});
    },
    editSettings: function () {
        new PJQ.views.commitments.CommitmentSettingsModal({
            commitmentsView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    newCommitment: function (e) {
        let commitmentType = $(e.currentTarget).hasClass('new-po') ? PJQ.constants.commitments.commitmentType.PURCHASE_ORDER : PJQ.constants.commitments.commitmentType.SUBCONTRACT;
        this.viewCommitment(null, commitmentType);
    },
    viewCommitmentClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        if (row != null) {
            this.viewCommitment(row.data());
        }
    },
    viewCommitment: function (commitment, commitmentType) {
        let isNew = commitment == null
        new PJQ.views.commitments.CommitmentEditModal({
            model: commitment,
            commitmentType: commitmentType,
            onChangeOrderAdd: _.bind(function (changeOrder) {
                if (typeof this.options.onChangeOrderAdd === 'function') {
                    this.options.onChangeOrderAdd(changeOrder);
                }
            }, this),
            onChangeOrderDelete: _.bind(function (changeOrderId) {
                if (typeof this.options.onChangeOrderDelete === 'function') {
                    this.options.onChangeOrderDelete(changeOrderId);
                }
            }, this),
            onInvoiceAdd: _.bind(function (invoice) {
                if (typeof this.options.onChangeOrderAdd === 'function') {
                    this.options.onInvoiceAdd(invoice);
                }
            }, this),
            onSave: _.bind(function (commitment) {
                if (isNew) {
                    this.collection.add(commitment);
                }
                this.renderView();

                if (typeof this.options.onCommitmentSave === 'function') {
                    this.options.onCommitmentSave(commitment);
                }
            }, this),
            onDelete: _.bind(function (commitment) {
                this.collection.remove(commitment);
                this.renderView();

                if (typeof this.options.onCommitmentDelete === 'function') {
                    this.options.onCommitmentDelete(commitment);
                }
            }, this)
        })
    },
    deleteCommitmentClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteCommitment(row);
    },
    deleteCommitment: function (row) {
        if (row != null) {
            let commitment = row.data();
            if (commitment != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Commitment",
                    body: "Are you sure you want to delete this Commitment?",
                    onDelete: _.bind(function () {
                        commitment.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(commitment);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    }
});

PJQ.views.commitments.ModalViewCommitments = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-view-change-orders'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.commitments.CommitmentsList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                project: this.options.project
            })
        }
    },
});

PJQ.views.commitments.SelectCommitmentsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'modal-select-commitments'),
        width: '60%',
        maxWidth: 700,
        onSave: _.noop,
        selectedCommitmentId: null,
        headerSubText: null
    },
    events: {
        "change .select-commitment": "selectCommitment",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.isAdmin = PJQ.app.session.project.hasPermission('commitments.isAdmin');

        this.selectedCommitment = null;
        this.selectedCommitments = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.commitments.Commitments(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        await this.collection.fetch();

        if (this.options.selectedCommitmentId != null) {
            this.selectedCommitment = this.collection.get(this.options.selectedCommitmentId);
        }

        if (this.options.filterStatuses) {
            this.collection.models = _.filter(this.collection.models, function (model) {
                let statusId = model.get('statusId');

                if (_.isArray(this.options.filterStatuses)) {
                    return _.includes(this.options.filterStatuses, statusId);
                } else if (_.isNumber(this.options.filterStatuses)) {
                    return this.options.filterStatuses === statusId;
                }

                return false;

            }, this);
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice,
            hasSelected: this.options.isSingleChoice ? this.selectedCommitment != null : _.size(this.selectedCommitments) > 0
        }
    },
    isSelected: function (commitment) {
        if (this.options.isSingleChoice) {
            return this.selectedCommitment != null && this.selectedCommitment.cid === commitment.cid;
        }
        return this.selectedCommitments != null && this.selectedCommitments.indexOf(commitment.cid);
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.commitments-table'),
            data: this.collection.models,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": (data, type, row) => {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (this.isSelected(row) ? 'checked' : '') + ' class="select-commitment"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.commitmentType",
                    "title": "Type",
                    "width": "110px",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.commitments.commitmentTypeNames[row.get('commitmentType')]
                    }, this)
                },
                {
                    "columnData": "attributes.contractedContact.companyName",
                    "title": "Company",
                    "titleSettings": "Contracted Company",
                    "render": _.bind(function (data, type, row) {
                        return row.get('contractedContact') ? row.get('contractedContact').companyName : 'N/A';
                    }, this)
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectCommitment: function (e) {
        let target = $(e.currentTarget),
            commitment = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-commitment').not(target).text('Select').prop('checked', false);
            if (commitment.get('isSelected')) {
                commitment.set('isSelected', false);
                this.selectedCommitment = null;
            } else {
                commitment.set('isSelected', true);
                this.selectedCommitment = commitment;
                this.collection.get(commitment.id);
                _.each(this.collection.models, _.bind(function (dtCommitment) {
                    if (commitment.id !== dtCommitment.id)
                        dtCommitment.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedCommitment == null);

            if (typeof this.options.onCommitmentSelected === 'function') {
                this.options.onCommitmentSelected(this.selectedCommitment);
            }
        } else {
            if (commitment.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                commitment.set('isSelected', false);
                this.selectedCommitments = _.reject(this.selectedCommitments, function (selCommitment) {
                    return selCommitment.id === commitment.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                commitment.set('isSelected', true);
                this.selectedCommitments.push(commitment);
            }
            this.$('.btn-save').attr('disabled', this.selectedCommitments == null);

            if (typeof this.options.onCommitmentSelected === 'function') {
                this.options.onCommitmentSelected(this.selectedCommitments);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedCommitment ? this.selectedCommitment : this.selectedCommitments);
            this.removeModal();
        }
    }
});